import type { ReactNode } from 'react';

export const symbol_note_stack: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M340-620v480h308v-142q0-12.75 8.63-21.38Q665.25-312 678-312h142v-308H340Zm240 240ZM280-140v-480q0-25.06 17.5-42.53Q315-680 340-680h480q24.75 0 42.38 17.62Q880-644.75 880-620v315q0 12.44-5 23.72T862-262L698-98q-8 8-19.28 13-11.28 5-23.72 5H340q-24.75 0-42.37-17.63Q280-115.25 280-140ZM81-725q-5-25 9.5-44.5T130-794l473-84q24-5 44 9.5t25 38.5l10 55q2 14-5.5 23T658-741q-11 2-21.5-3.5T624-764l-10-55-473 83 74 423q2 11-4 21t-17 13q-13 3-24-3.5T157-302L81-725Z"
		/>
	</svg>
);
